export const stripMarkdownHandler = (markdown: string): string => markdown.
    replace(
        /^#{1,6}\s+/gm,
        "",
    ).
    replace(
        /\*\*(.+?)\*\*/g,
        "$1",
    ).
    replace(
        /__(.+?)__/g,
        "$1",
    ).
    replace(
        /\*(.+?)\*/g,
        "$1",
    ).
    replace(
        /_(.+?)_/g,
        "$1",
    ).
    replace(
        /^[-*]{3,}\s*$/gm,
        "",
    ).
    replace(
        /^[\s]*[-*]\s+/gm,
        "• ",
    ).
    replace(
        /^[\s]*\d+\.\s+/gm,
        "",
    ).
    replace(
        /\n{3,}/g,
        "\n\n",
    ).
    trim();
